import React from 'react'
import styled from 'styled-components'
import IconLarge from '../../images/icon-user-group-large.svg'
import IconSmall from '../../images/icon-user-group-small.svg'

const RespondentGroups = ({ items, size = 'large', useTranslate }) => (
  <Container>
    <img src={size === 'small' ? IconSmall : IconLarge} alt="" />
    <Label size={size}>
      {useTranslate('data_vault.respondent_groups')} ({items.length})
      <Tooltip>{items.map((item, i) => <div key={i}>{item}</div>)}</Tooltip>
      <TooltipArrow />
    </Label>
  </Container>
)

export default RespondentGroups

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-left: auto;
`

const Tooltip = styled.div`
  display: none;
  position: absolute;
  bottom: calc(100% + 11px);
  left: 50%;
  transform: translateX(-50%);
  background-color: #F58220;
  color: white;
  padding: 8px 16px;
  border-radius: 4px;
  white-space: nowrap;
  font-size: 12px;
  z-index: 100;
  text-align: center;
`

const TooltipArrow = styled.div`
  display: none;
  position: absolute;
  bottom: calc(100% + 7px);
  left: 50%;
  transform: translateX(-50%);
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #F58220;
  z-index: 101;
`

const Label = styled.span`
  font-size: ${({ size }) => size === 'small' ? '12px' : '14px'};
  position: relative;
  cursor: default;

  &:hover ${Tooltip}, &:hover ${TooltipArrow} {
    display: block;
    animation: tooltip-appear 0s 0.2s both;
  }

  @keyframes tooltip-appear {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`



// WEBPACK FOOTER //
// ./src/components/ui/respondent-groups.js